/*  Shared  */
import BusinessOwnerPicker from 'application/Shared/Components/Pickers/BusinessOwner';

/* YARN */
import i18n from 'i18n';
import React from 'react';

const { t } = i18n;

const filterableOptions = [
    {
        name: t('Common.managed_by_partner'),
        parameter: 'managedByPartner',
        render: (
            <BusinessOwnerPicker
                visualOnly
                value=""
                noBusinessOwnerRequired={false}
                managedByPartner
                managed3rdParty={false}
            />
        ),
        value: 'true'
    },
    {
        name: t('Common.managed_by_3rd_party'),
        parameter: 'managed3rdParty',
        render: (
            <BusinessOwnerPicker
                visualOnly
                value=""
                noBusinessOwnerRequired={false}
                managedByPartner={false}
                managed3rdParty
            />
        ),
        value: 'true'
    },
    {
        name: t('Common.noBusinessOwnerRequired'),
        parameter: 'noBusinessOwnerRequired',
        render: (
            <BusinessOwnerPicker
                visualOnly
                value=""
                noBusinessOwnerRequired
                managedByPartner={false}
                managed3rdParty={false}
            />
        ),
        value: 'true'
    }
];

const header = {
    field: 'business_owner',
    filterable: true,
    filterableOptions,
    name: 'Common.owner',
    sortable: false,
    sortableFieldType: 'string',
    sortableKey: 'business_owner',
    tooltip: 'business_owner',
    width: '15%'
};

export default header;
